/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useEffect, ElementRef, useRef } from 'react'
import { fromRange, toRange } from 'xpath-range'
import { toast } from 'react-toastify'
// import generateHTML from '../../utils/generateHTML'
import generateHTML from 'utils/generateHTML'

import ExcertTools from 'components/ExcertTools'
import SendDoubt from 'components/SendDoubt'
import { windowGetSelection, highlightRanges, getXpathParameters } from 'utils/highlightUtils'
import { calculateTooltipPosition } from './utils'

import { v4 as uuid } from 'uuid'

import { Dangerous, FinishButton } from './styles'
import { learningApi } from 'services/api'
import { useSelector } from 'react-redux'
import { RootState } from 'store/modules/rootReducer'
import ModalFreemium from 'components/ModalFreemium'
import { WrapperContainer } from '../../../Course/components/ModuleAcordeon/styles'

import Direcao from 'assets/logos/direcao-square.png'
import ContentLoader from 'react-content-loader'
import ToolsMenu from '../ToolsMenu'
import Scroll from 'react-scroll'
import { useLocation } from 'react-router-dom'
import { useLessonContext } from 'pages/Lesson/context'
import { useLessonParams } from 'pages/Lesson/hooks/use-lesson-params'
import { throttle } from 'lodash'
import { useLocalStorage, useMount } from 'react-use'

interface TextLessonProps {
  handleContentNavigate(type: string): void
}

const TextLesson: React.FC<TextLessonProps> = ({ handleContentNavigate }) => {
  const [selection, setSelection] = useState<string>('')
  const [selectionId, setSelectionId] = useState<string>('')
  const [annotationId, setAnnotationId] = useState<string>('')
  const [left, setLeft] = useState<number>(0)
  const [top, setTop] = useState<number>(0)
  const [openTools, setOpenTools] = useState<boolean>(false)
  const [fontSize, setFontSize] = useLocalStorage<number>('text-lesson--font-size', 1)
  const [openDoubt, setOpenDoubt] = useState<boolean>(false)
  const [loadingFinishLesson, setLoadingFinishLesson] = useState<boolean>(false)
  const [annotationType, setAnnotationType] = useState<'annotation' | 'doubt' | null>(null)
  const [itemId, setItemId] = useState<any>(null)
  const [openModalFreemium, setOpenModalFreemium] = useState(false)

  const [activeElement, setActiveElement] = useState<any | null>(null)
  const [annotations, setAnnotations] = useState([])
  const [loading, setLoading] = useState(false)

  const token = localStorage.getItem('token')
  const { isDarkMode } = useSelector((state: RootState) => state.theme)

  const timeRef = useRef(new Date())
  const scrollableRef = useRef<ElementRef<'main'>>(
    document.querySelector('#layout--scrollable-area')
  )

  const [htmlContents, setHtmlContents] = useState<Array<{ _id: string; html: string }>>([])

  const { courseId, lessonId, moduleId, chapterId } = useLessonParams()
  const { swrMenuContent, swrLesson } = useLessonContext()

  const menuData = swrMenuContent.data
  const { data: lessonData, excertoContents } = swrLesson

  const detectMob = useCallback(() => {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ]

    // Specific verification for iPad devices using Safari Browser
    if (
      /Macintosh/i.test(navigator.userAgent) &&
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 1
    ) {
      return true
    }

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem)
    })
  }, [])

  const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect()

    return (
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
      rect.top < (window.innerHeight || document.documentElement.clientHeight)
    )
  }

  useMount(() => {
    const scrollableEl = scrollableRef.current

    const postExcertoMonitoring = throttle(async () => {
      const winTop = scrollableEl.scrollTop

      const windowBottom = winTop + window.outerHeight
      excertoContents.map(async (t) => {
        const el = document.getElementById(t._id)
        const { top, height } = el.getBoundingClientRect()
        if (height - el.offsetTop - +top > 0 && isElementInViewport(el)) {
          const targetBottom = el.offsetTop + el.scrollHeight
          const progress = +(
            100 -
            ((targetBottom - windowBottom + window.outerHeight / 3) /
              (targetBottom - window.outerHeight + window.outerHeight / 3)) *
              100
          ).toFixed(2)
          if (progress > 0) {
            await handleMonitoring({
              _id: t._id,
              name: t.name,
              progress: progress > 100 ? 100 : progress,
              time: (new Date().getTime() - timeRef.current.getTime()) / 1000,
            })

            timeRef.current = new Date()
          }
        }
      })
    }, 2000)

    const onScroll = () => {
      postExcertoMonitoring()
    }

    scrollableEl.addEventListener('scroll', onScroll)

    return () => {
      scrollableEl.removeEventListener('scroll', onScroll)
    }
  })

  const onMouseUp = (event, _id?: string) => {
    event.preventDefault()

    const select = windowGetSelection()
    const selection = select.toString().trim()

    const isSelectionEmpty = selection.length === 0

    if (select.rangeCount > 0 && !isSelectionEmpty) {
      setSelection(selection)
      setSelectionId(_id || itemId)

      const { left, top } = calculateTooltipPosition(select, 260)

      setActiveElement(null)
      setOpenTools(true)
      setLeft(left)
      setTop(top)
    }

    if (isSelectionEmpty) {
      setOpenTools(false)
      setActiveElement(null)
      setAnnotationId(null)
    }
  }

  useEffect(() => {
    const isMobile = detectMob()

    if (isMobile) {
      document.addEventListener('selectionchange', (e) => onMouseUp(e, itemId))
      return () => {
        document.removeEventListener('selectionchange', (e) => onMouseUp(e, itemId))
      }
    }
  }, [itemId])

  const getSourceType = useCallback(() => {
    if (menuData.course?.isFreemium) {
      return 'freemium'
    }

    if (menuData.course?.isSubscription) {
      return 'subscription'
    }

    return 'course'
  }, [menuData.course])

  const handleMonitoring = useCallback(
    async (item) => {
      if (
        !lessonData.chapter?.name ||
        !menuData.course?.name ||
        !menuData.module?.name ||
        !lessonData?.name
      ) {
        return
      }

      await learningApi
        .post(
          '/content/monitoring/excerpt',
          {
            chapter: {
              _id: chapterId,
              name: lessonData.chapter?.name,
            },
            course: {
              _id: courseId,
              name: menuData.course?.name,
            },
            module: {
              _id: moduleId,
              name: menuData.module?.name,
            },
            lesson: {
              _id: lessonId,
              name: lessonData?.name || 'Direção Concursos',
            },
            object: {
              _id: item?._id,
              name: item?.name,
            },
            current: item.progress,
            duration: 100,
            time: item?.time,
            userAction: item?.progress && item?.progress >= 100 ? 1 : 0,
            source: getSourceType(),
            subscription: menuData.course?.subscription,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .catch((err) => {
          if (err.response.status === 401) return
          console.error(err)
          toast.error('Houve um erro ao registrar o seu progresso!')
        })
    },
    [
      courseId,
      menuData.course,
      menuData.course?.name,
      moduleId,
      menuData.module,
      menuData.module?.name,
      lessonId,
      lessonData,
      lessonData?.name,
      chapterId,
      lessonData.chapter,
      lessonData.chapter?.name,
      token,
    ]
  )

  const handleFinish = async () => {
    setLoadingFinishLesson(true)
    // Não realizar um Promise.all por conta que mandando tudo de uma só vez, um update pode sobrescrever o outro no summarizedmonitorings !!!!
    for (const content of excertoContents) {
      await handleMonitoring({
        _id: content?._id,
        name: content?.name,
        progress: 100,
        time: (new Date().getTime() - timeRef.current.getTime()) / 1000,
      })
    }
    timeRef.current = new Date()
    setLoadingFinishLesson(false)

    swrMenuContent.completeChapter({ lessonId, chapterId, isCompleted: true })

    handleContentNavigate('next')
  }

  const handleOpenAnnotationModal = useCallback((type: 'annotation' | 'doubt') => {
    setAnnotationType(type)
    setOpenDoubt(true)
  }, [])

  const handleGetAnnotation = useCallback(() => {
    setOpenDoubt(false)
  }, [])

  const onHighlightSelect = (e) => {
    if (e.target.className?.match(/highlight/gi)) {
      e.preventDefault()

      setActiveElement(e.target)

      const annotation = annotations.find((a) => {
        return a.highlight?.uuid === e.target?.id
      })
      setSelection(annotation?.highlight?.text)
      setAnnotationId(annotation?._id)

      const { left, top } = calculateTooltipPosition(e.target, 340)
      setLeft(left)
      setTop(top)
      setOpenTools(true)
    }
  }

  const restoreHighlights = (ann) => {
    ann.map((a) => {
      const { uuid: highlightId, color, startOffset, endOffset } = a.highlight
      const root = document.querySelector(`[id="${a.object._id}"]`)
      const start = a.highlight.start.replace(/\/([a-z]+)\[\d{1,}\]$/gim, '::$1()')
      const end = a.highlight.end.replace(/\/([a-z]+)\[\d{1,}\]$/gim, '::$1()')

      try {
        const range = toRange(start, startOffset, end, endOffset, root)
        return highlightRanges(range, 'mark', {
          id: highlightId,
          class: color,
        })
      } catch (error) {
        return console.error(start, end, error)
      }
    })

    setAnnotations(ann)
  }

  const handleGetAnnotations = useCallback(async () => {
    setLoading(true)
    const annotationsApi = await learningApi.post(
      '/annotation/get-annotation',
      {
        courseId: courseId,
        moduleId: moduleId,
        lessonId: lessonId,
        chapterId: chapterId,
        objectType: 'excerpt',
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    setLoading(false)
    restoreHighlights(annotationsApi.data.filter(({ highlight }) => highlight))
  }, [chapterId, courseId, lessonId, moduleId, token, excertoContents.length, setLoading])

  const handleDeleteAnnotations = useCallback(
    async (_id) => {
      if (_id)
        await learningApi.delete(`/annotation/${_id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
    },
    [token]
  )

  const handlePatchAnnotations = async (_id: string, highlight) => {
    await learningApi.patch(`/annotation/${_id}`, highlight, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  const handlePatchColorAnnotations = async (id: string, color) => {
    await learningApi.patch(
      `/annotation/${id}`,
      { color },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  }

  useEffect(() => {
    handleGetAnnotations()
  }, [excertoContents.length, handleGetAnnotations, token])

  const removeHighlight = (highlightElement) => {
    if (highlightElement.childNodes.length === 1) {
      highlightElement.parentNode.replaceChild(highlightElement.firstChild, highlightElement)
    } else {
      while (highlightElement.firstChild) {
        highlightElement.parentNode.insertBefore(highlightElement.firstChild, highlightElement)
      }
      highlightElement.remove()
    }

    setActiveElement(null)
    setOpenTools(false)
    setAnnotationId(null)
  }

  const setHighlight = (className: string) => {
    const text = (windowGetSelection() && windowGetSelection().toString()) || ''

    if (!text || text === ' ') {
      if (activeElement) {
        const { id } = activeElement
        const highlightedElements = Array.from(document.querySelectorAll(`[id="${id}"]`))
        if (!className) {
          highlightedElements.map((t) => removeHighlight(t))
          handleDeleteAnnotations(annotationId)
        } else {
          highlightedElements.map((t) => {
            t.classList.remove(t.classList.value)
            return t.classList.add(className)
          })
          setOpenTools(false)
          const annotation = annotations.find((a) => a.highlight?.uuid === id)
          handlePatchAnnotations(annotation?._id, {
            highlight: { ...annotation?.highlight, color: className },
          })
        }
      }
      return
    }

    const selection = getSelection()
    const parentSelection = selection.anchorNode.parentNode

    let incrementedOffset = 0

    for (const index in parentSelection.childNodes) {
      if (parentSelection.childNodes[index].isEqualNode(selection.anchorNode)) {
        break
      }

      incrementedOffset += parentSelection.childNodes[index].textContent.length
    }

    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0)

      const content = document.getElementById(selectionId)
      let xpath = null
      if (content) {
        xpath = fromRange(range, content)
      }
      if (xpath) {
        try {
          const highlightId = uuid()
          highlightRanges(range, 'mark', { id: highlightId, class: className })

          const { startOffset, endOffset, start, end } = getXpathParameters(xpath)

          windowGetSelection()?.removeAllRanges()
          setOpenTools(false)

          const { _id, apprenticeshipObjectSeletedName: name } = excertoContents.find(
            (e) => e?._id === selectionId
          )

          saveAnnotation({
            text,
            uuid: highlightId,
            color: className,
            startOffset: startOffset + incrementedOffset,
            endOffset: endOffset + incrementedOffset,
            start,
            end,
            object: { _id, name },
          })
        } catch (e) {
          console.error('user highlight failed: ', e)
        }
      }
    }
  }

  const setColor = ({ id, color }) => {
    handlePatchColorAnnotations(id, color)
  }

  const saveAnnotation = useCallback(
    async (data) => {
      const { text, uuid, color, startOffset, endOffset, start, end, object } = data

      const reqData: any = {
        course: {
          _id: courseId,
        },
        module: {
          _id: moduleId,
          name: menuData.module?.name,
        },
        lesson: {
          _id: lessonId,
          name: lessonData?.name || 'Direção Concursos',
        },
        chapter: {
          _id: chapterId,
          name: lessonData.chapter?.name,
        },
        object: {
          ...object,
          type: 'excerpt',
        },
        highlight: {
          text,
          uuid,
          color,
          startOffset,
          endOffset,
          start,
          end,
        },
      }

      const result = await learningApi.post('/annotation/save-annotation', reqData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      setAnnotations([...annotations, result.data])
    },
    [
      annotations,
      chapterId,
      lessonData.chapter,
      courseId,
      menuData.course,
      lessonId,
      lessonData,
      moduleId,
      menuData.module,
      token,
    ]
  )

  const parseExcertosHTML = async () => {
    const parsedHTML = await Promise.all(
      excertoContents.map(async (excerto) => {
        const json = await fetch(excerto.json).then((res) => res.json())

        const html = generateHTML(json)

        return {
          _id: excerto._id,
          html,
        }
      })
    )

    setHtmlContents(parsedHTML)
  }

  useEffect(() => {
    if (excertoContents.length) parseExcertosHTML()
  }, [excertoContents])

  const { hash } = useLocation()

  /**Scrolla a tela para o excerto contido na URL (e.g: .../lesson/:id/#hashExcerto) */
  const handleExcerptAnchorScroll = (hash) => {
    const excerptElement = document.getElementById(hash)

    if (!excerptElement) return

    excerptElement.scrollIntoView({ behavior: 'auto', block: 'start' })
  }

  useEffect(() => {
    if (hash && !loading && htmlContents && htmlContents.length)
      handleExcerptAnchorScroll(hash.substring(1))
  }, [loading, htmlContents])

  useEffect(() => {
    if (chapterId && !hash) {
      const scroll = Scroll.animateScroll
      scroll.scrollToTop(0.0)
    }
  }, [chapterId])

  const RenderModalFreemium = () => {
    const moduleInfo = {
      _id: menuData.module?._id,
      name: menuData.module.name,
      icon: menuData.course.icon ?? Direcao,
      discount: menuData.module.discount,
      permanentLink: menuData.module.permanentLink,
      qtd_videos: menuData.module.total.video?.amount,
      qtd_pdf: menuData.module.total.excerto?.amount,
    }

    const courseInfo = {
      _id: menuData.course?._id,
      name: menuData.course.name,
      icon: menuData.course.icon ?? Direcao,
      discount: menuData.course.discount,
      permanentLink: menuData.course.permanentLink,
      qtd_videos: menuData.course.totalCourse.videos?.amount,
      qtd_pdf: menuData.course.totalCourse.excertos?.amount,
    }

    return (
      <WrapperContainer>
        <ModalFreemium
          module={moduleInfo}
          course={courseInfo}
          subscription={menuData?.course?.isFreemium && menuData?.course?.isSubscription}
          setOpenModal={setOpenModalFreemium}
        />
      </WrapperContainer>
    )
  }

  const LoaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
  }

  return (
    <>
      {openTools && (
        <ExcertTools
          left={left}
          top={top}
          selection={selection}
          openAnnotation={handleOpenAnnotationModal}
          setHighlight={setHighlight}
          isHighlighted={!!activeElement}
        />
      )}
      <div>
        {htmlContents.length > 0 ? (
          htmlContents.map((item, idx) => (
            <Dangerous
              fontSize={fontSize}
              className="excerto"
              key={idx}
              id={item?._id}
              draggable="false"
              onMouseUp={(e) => onMouseUp(e, item._id)}
              onPointerDown={() => {
                setItemId(item._id)
              }}
              onClick={(e) => {
                onHighlightSelect(e)
              }}
              dangerouslySetInnerHTML={{ __html: item?.html }}
              isDarkMode={isDarkMode}
            />
          ))
        ) : (
          <ContentLoader width={'95%'} height={500} viewBox={'0 0 100% 100%'} {...LoaderProps}>
            <rect x="50" y="20" rx="15" ry="15" width="90%" height="400" />
          </ContentLoader>
        )}
      </div>
      <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
        <FinishButton onClick={handleFinish} disabled={loadingFinishLesson}>
          Finalizar capítulo
        </FinishButton>
      </div>
      <ToolsMenu
        objectId={excertoContents.length ? excertoContents[0]?._id : null} //PRECISAMOS AJUSTAR ISSO
        setColor={setColor}
        name={lessonData.chapter?.name}
        setFontSize={setFontSize}
        fontSize={fontSize}
        isFreemium={menuData.course?.isFreemium}
        setOpenModalFreemium={setOpenModalFreemium}
      />
      {openDoubt && (
        <SendDoubt
          type={annotationType}
          text={selection}
          annotationId={annotationId}
          title={annotationType === 'doubt' ? 'Enviar dúvida' : 'Anotar'}
          close={() => setOpenDoubt(false)}
          chapterId={chapterId}
          videoId={excertoContents.length ? excertoContents[0]?._id : null} //PRECISAMOS AJUSTAR ISSO
          lessonId={lessonId}
          objectId={excertoContents.map(({ _id }) => _id).find((id) => id === selectionId)}
          moduleId={moduleId}
          courseId={courseId}
          teacher={excertoContents.length ? excertoContents[0]?.teacher?._id : null}
          teacherName={excertoContents.length ? excertoContents[0]?.teacher?.name : null}
          courseName={menuData.course?.name}
          moduleName={menuData.module?.name}
          refetchAnnotations={handleGetAnnotation}
          isText
          isFreemium={menuData.course?.isFreemium}
          setOpenModalFreemium={setOpenModalFreemium}
        />
      )}
      {openModalFreemium && RenderModalFreemium()}
    </>
  )
}

export default TextLesson
